'use client';

import { useAtomValue } from 'jotai';

import { tw } from '@repo/ui';

import { registerSuccessAtom } from '../../../atoms';
import { Footer } from '../../../components/footer';
import { SocialLinks } from '../../../components/social-links';
import { Breakdown } from '../../../components/views/claim/breakdown';
import { RegisterSuccess } from '../../success/register-success';

export const Register: React.FC = () => {
  const registerSuccess = useAtomValue(registerSuccessAtom);

  return (
    <>
      <div
        className={tw(
          'mb-8 w-full rounded-[18px]',
          'z-10 mx-auto max-w-screen-sm',
          'bg-[#444444]/25',
        )}
      >
        {registerSuccess ? (
          <div
            className={tw(
              'relative flex flex-col items-center gap-7 text-white',
              'min-h-[560px] justify-end md:min-h-[622px]',
            )}
          >
            <RegisterSuccess />
          </div>
        ) : (
          <Breakdown isClaimActive={false} />
        )}
      </div>

      {registerSuccess ? (
        <SocialLinks theme='green' />
      ) : (
        <div className='mx-auto w-full max-w-screen-sm px-2'>
          <Footer />
        </div>
      )}
    </>
  );
};
